/**
 * Limites do formato. Ficam isolados porque a interface os mostra ao autor
 * ANTES de ele tentar publicar — um contador de caracteres que discorde da
 * recusa do servidor e pior que nao ter contador.
 */
/** Slug da skill. O padrao e um nome de pasta, e e por isso que nao aceita maiuscula nem espaco. */
export const SKILL_NAME_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
export const SKILL_NAME_MAX_LENGTH = 64;
/**
 * A descricao e o unico texto que o agente ve na camada 1, para TODAS as skills
 * de uma vez. O teto existe para que o catalogo inteiro caiba no contexto.
 */
export const SKILL_DESCRIPTION_MAX_LENGTH = 1024;
/**
 * Teto por material de apoio e do pacote inteiro, em bytes.
 *
 * O pacote sobe de 5 MB para 50 MB em 21/09/2026. O numero antigo nao tinha
 * justificativa registrada, e na pratica nunca foi alcancavel: o corpo JSON da
 * api aceitava 1 MB (o padrao do framework), entao o pacote era barrado no HTTP
 * antes de chegar a esta regra. Subir aqui exigiu subir o `json.limit` do
 * bodyparser junto.
 *
 * O teto por ARQUIVO fica abaixo do teto do pacote de proposito: ele nao existe
 * para limitar o total — isso o outro faz —, e sim para impedir que um unico
 * arquivo consuma o pacote inteiro. Material de apoio e lido pelo agente sob
 * demanda; um arquivo de dezenas de MB nao seria util a ele de qualquer forma.
 */
export const SKILL_FILE_MAX_BYTES = 10 * 1024 * 1024;
export const SKILL_PACKAGE_MAX_BYTES = 50 * 1024 * 1024;
/**
 * Chaves de `metadata` que NAO sao comandos da skill.
 *
 * A spec usa `metadata` como mapa livre e, no proprio exemplo dela, guarda ali
 * `author` e `version`. Como o Prodgy le as demais chaves como comandos —
 * entradas nomeadas do procedimento —, estas precisam ser excluidas, senao o
 * autor da skill apareceria contado como um comando dela.
 */
/**
 * Prefixo das chaves de `metadata` que declaram PARAMETRO da skill (AB#85634).
 *
 * Elas nao sao comandos, e por serem uma por parametro nao caberiam numa lista
 * fixa de reservadas — dai o recorte por prefixo.
 */
/**
 * Prefixo das chaves de `metadata` que declaram parametro no formato ANTIGO.
 *
 * Hifen, e nao ponto: a chave do frontmatter casa com `[A-Za-z0-9_-]+`, entao
 * `param.x` seria recusado na leitura. Skill nova declara parametro no bloco
 * `parameters` do topo (AB#85634); isto fica para o acervo ja publicado.
 */
export const SKILL_PARAMETER_PREFIX = 'param-';
export const SKILL_RESERVED_METADATA_KEYS = [
    'author',
    // Quem FORNECE a skill — a casa, distinta de quem a escreveu (AB#85634).
    // Reservada junto das demais: sem isso ela viraria um comando fantasma em
    // toda skill que a declarasse, porque comando e toda chave nao reservada.
    'provider',
    // Os parametros NAO precisam ser reservados aqui: desde AB#85634 eles vivem
    // no bloco `parameters` do TOPO do frontmatter, fora de `metadata`, e por
    // isso nao concorrem com os comandos. O prefixo acima cobre o acervo antigo,
    // que os declarava aqui dentro.
    'version',
    'required-integrations',
    'required_integrations',
    'required-tools',
    'required_tools',
];
/** Nome fixo do arquivo de instrucoes, definido pelo padrao. */
export const SKILL_ENTRY_FILE = 'SKILL.md';
//# sourceMappingURL=limits.js.map